import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.496 4A3.495 3.495 0 004 7.496v9.008A3.495 3.495 0 007.496 20h9.008A3.495 3.495 0 0020 16.505V7.496A3.495 3.495 0 0016.505 4H7.496zM2 7.496A5.495 5.495 0 017.496 2h9.009A5.495 5.495 0 0122 7.496v9.009A5.495 5.495 0 0116.504 22H7.496A5.495 5.495 0 012 16.504V7.496zm14.944-1.783h.005c.734 0 1.342.595 1.338 1.343l-.675-.003V7.05h.675v.005a1.337 1.337 0 11-1.343-1.343zM12 9.4a2.6 2.6 0 100 5.2 2.6 2.6 0 000-5.2zM7.4 12a4.6 4.6 0 119.2 0 4.6 4.6 0 01-9.2 0z",
      fill: "#2d6ded"
    }
  )
), a = t;
export {
  a as default
};
